// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
    position: relative;
}

.custom-select .select-option {
    padding: 8px;
    cursor: pointer;
}

.custom-select .select-option:hover {
    background-color: cadetblue; /* Mor renk hover durumunda */
}

.custom-select .select-option:active {
    background-color: blue; /* Mavi renk seçildiğinde */
    color: white; /* Yazı rengini beyaz yapabilirsiniz, isteğe bağlı */
}`, "",{"version":3,"sources":["webpack://./src/pages/pages/profile/Profile.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B,EAAE,6BAA6B;AAC9D;;AAEA;IACI,sBAAsB,EAAE,2BAA2B;IACnD,YAAY,EAAE,oDAAoD;AACtE","sourcesContent":[".custom-select {\n    position: relative;\n}\n\n.custom-select .select-option {\n    padding: 8px;\n    cursor: pointer;\n}\n\n.custom-select .select-option:hover {\n    background-color: cadetblue; /* Mor renk hover durumunda */\n}\n\n.custom-select .select-option:active {\n    background-color: blue; /* Mavi renk seçildiğinde */\n    color: white; /* Yazı rengini beyaz yapabilirsiniz, isteğe bağlı */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
